import { SxProps, Theme } from "@mui/material/styles";

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    width: "100%",
  },
  viewport: {
    flex: 1,
    overflow: "hidden",
  },
  track: {
    display: "flex",
    transition: "transform 0.4s ease",
    willChange: "transform",
  },
  arrowHidden: {
    visibility: "hidden",
    pointerEvents: "none",
  },
};
